document.addEventListener("DOMContentLoaded", function (event) {
    const audioPlayers = document.querySelectorAll('.audio-player-container');

    if(audioPlayers.length === 0) {
        return; // No audio players found, exit early
    }
    audioPlayers.forEach(function (audioplayer) {
        const audio = audioplayer.querySelector('audio');
        if(!audio) {
            return; // No audio element found, skip this player
        }
        audio.load(); // Preload the audio

        //Play / Pause button
        const playButton = audioplayer.querySelector('.play-button');
        playButton.addEventListener('click', function () {
            if (audio.paused) {
                audio.play();
                playButton.classList.add('playing');
            } else {
                audio.pause();
                playButton.classList.remove('playing');
            }
        });

        // Update button state when audio ends
        audio.addEventListener('ended', function () {
            playButton.classList.remove('playing');
        });

        // Current Time and Duration Display
        const currentTimeDisplay = audioplayer.querySelector('.current-time');
        const durationDisplay = audioplayer.querySelector('.duration');

        if(currentTimeDisplay && durationDisplay) {
            audio.addEventListener('loadedmetadata', function () {
                const duration = formatTime(audio.duration);
                durationDisplay.textContent = duration;
            });

            audio.addEventListener('timeupdate', function () {
                const currentTime = formatTime(audio.currentTime);
                currentTimeDisplay.textContent = currentTime  + ' /';
            });
        }

        // Helper function to format time in mm:ss
        function formatTime(seconds) {
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
        }
    });
});
